import React from "react"
import _ from "lodash"
import { useParams, useNavigate } from "react-router-dom"

import useGetDoc from "../../hooks/useGetDoc"

//comps
import { LoaderSmall } from "../../components/Loaders"
import FormWrapper from "./FormWrapper"

export default function Edit() {
  const { docId } = useParams()
  const [loading, error, data] = useGetDoc("mrf_orders", docId)
  // Keys that are Firestore internals (DocumentReferences, Timestamps, computed
  // results) — strip them so they never end up serialized into the POST body.
  const STRIP_KEYS = new Set([
    "ref_mrf",
    "ref_data_order",
    "timestamp_created",
    "timestamp_updated",
    "mrfMetadata",
    "result_index_process",
    "result_process",
    "result_preprocess",
  ])

  const handleData = _.reduce(
    data,
    (acc, value, key) => {
      if (STRIP_KEYS.has(key)) return acc
      if (key === "ref_carrier_directory") {
        return { ...acc, ref_carrier_directory: value.id }
      }
      return { ...acc, [key]: value }
    },
    {}
  )

  handleData.id = docId
  if (!handleData.process_version) handleData.process_version = ""

  if (error) {
    return (
      <div>
        <h2>Error when fetching.</h2>
      </div>
    )
  }
  if (loading) return <LoaderSmall />
  return (
    <div className="container">
      <h1>Edit Index File</h1>
      <FormWrapper type="edit" docValues={handleData} />
    </div>
  )
}
